var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useMemo } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { classNames, cn } from '@shapeable/utils';
var cls = classNames('entity-base-select');
import { breakpoints, theme } from '@shapeable/theme';
import ReactEntityBaseSelect, { components as Components } from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Highlighter } from '../elements/highlighter';
import { Icon } from '../elements/icon';
import { isEmpty, trim } from 'lodash';
import { ContentNode } from './content-node';
import { CrossIconGlyph, SearchIcon } from '@shapeable/icons';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
export var EntityBaseSelectDefaultProps = {
  variant: 'default',
  padOptions: true,
  maxMenuHeight: 500,
  indentUnits: 0,
  showSearchIcon: true,
  searchIconSize: 36,
  searchIconColor: 'strong'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var InputContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var SearchIconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", ";\n    ", "\n  "], ["\n    padding: ", ";\n    ", "\n  "])), theme.UNIT(0.5), function (props) {
    return props._isMulti && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-left: 2px;\n    "], ["\n      margin-left: 2px;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  InputContainer: styled.div.attrs(cls.attr('input-container'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), InputContainerStyles),
  SearchIcon: styled(Icon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SearchIconStyles)
};
export var EntityBaseSelect = function (props) {
  var className = props.className,
    variant = props.variant,
    colorVariant = props.colorVariant,
    padOptions = props.padOptions,
    indent = props.indent,
    focus = props.focus,
    searchIcon = props.searchIcon,
    showSearchIcon = props.showSearchIcon,
    searchIconSize = props.searchIconSize,
    searchIconColor = props.searchIconColor,
    indentUnits = props.indentUnits,
    selectProps = __rest(props, ["className", "variant", "colorVariant", "padOptions", "indent", "focus", "searchIcon", "showSearchIcon", "searchIconSize", "searchIconColor", "indentUnits"]);
  var isSearchable = selectProps.isSearchable,
    isMulti = selectProps.isMulti,
    size = selectProps.size,
    loadOptions = selectProps.loadOptions;
  var BaseSelect = !!loadOptions ? AsyncPaginate : ReactEntityBaseSelect;
  var contextTheme = useTheme();
  var isSearchOnly = isSearchable && !selectProps.loadOptionsOnMenuOpen;
  var Input = function (props) {
    var value = props.selectProps && props.selectProps.value;
    var hasValue = !isEmpty(value);
    return React.createElement(My.InputContainer, null, isSearchable && showSearchIcon && !hasValue && React.createElement(My.SearchIcon, {
      _isMulti: isMulti,
      color: searchIconColor,
      size: searchIconSize
    }, searchIcon || React.createElement(SearchIcon, null)), React.createElement(Components.Input, __assign({}, props)));
  };
  var ClearIndicator = function (props) {
    return React.createElement(Components.ClearIndicator, __assign({}, props), React.createElement(CrossIconGlyph, null));
  };
  var MultiValueRemove = function (props) {
    return React.createElement(Components.MultiValueRemove, __assign({}, props), React.createElement(CrossIconGlyph, null));
  };
  var Option = function (props) {
    var data = props.data,
      selectProps = props.selectProps;
    var inputValue = selectProps.inputValue;
    return React.createElement(Components.Option, __assign({}, props), React.createElement(Highlighter, {
      searchWords: [inputValue],
      textToHighlight: props.data.label
    }));
  };
  // allows us to use our props function builders by calling immediately on the current theme (from context)
  // which is likely what styled components does internally anyway.
  var $ = function (func) {
    return func({
      theme: contextTheme
    });
  };
  var BORDER_WIDTHS = {
    line: '0 0 1px 0',
    default: '1px',
    chromeless: '0'
  };
  var INDICATOR_DISPLAY = isSearchOnly ? 'none' : variant === 'default' ? 'flex' : 'none';
  var mode = useActiveThemeMode();
  var styles = useMemo(function () {
    return __assign({
      control: function (base, state) {
        return __assign(__assign({}, base), {
          borderRadius: 0,
          padding: variant === 'chromeless' ? $(theme.UNIT(0)) : $(theme.UNIT(1)),
          paddingLeft: indentUnits && $(theme.UNIT(indentUnits)) || (isSearchable ? !isEmpty(state.selectProps.value) ? 0 : $(theme.UNIT(2)) : $(theme.UNIT(2))),
          paddingBottom: variant === 'chromeless' ? '0px' : isMulti ? !isEmpty(state.selectProps.value) ? $(theme.UNIT(1)) : $(theme.UNIT(1)) : $(theme.UNIT(1)),
          outline: 'none',
          transition: 'none',
          minHeight: variant === 'chromeless' ? '44px' : '72px',
          fontFamily: $(theme.FONT('sans')),
          fontWeight: 400,
          fontSize: variant === 'chromeless' ? '18px' : '16px',
          boxShadow: 'none',
          background: variant === 'chromeless' ? 'transparent' : colorVariant === 'inverted' ? 'transparent' : $(theme.COLOR('bright')),
          borderWidth: BORDER_WIDTHS[variant],
          borderColor: $(theme.COLOR(state.isFocused ? variant === 'line' ? 'line-mid' : 'primary' : 'line-mid')),
          'path, circle, polygon, rect': {
            fill: "".concat($(theme.COLOR('strong')), " !important")
          },
          '&:hover': {
            borderColor: $(theme.COLOR(state.isFocused ? variant === 'line' ? 'line-mid' : 'primary' : 'line-mid'))
          }
        });
      },
      placeholder: function (base, state) {
        return __assign(__assign({}, base), {
          marginLeft: isSearchable ? showSearchIcon ? searchIconSize >= 40 ? '60px' : '48px' : '6px' : '2px',
          color: isSearchOnly ? $(theme.COLOR('text')) : $(theme.COLOR('text-mid')),
          fontWeight: isSearchOnly ? 500 : 400
        });
      },
      indicatorSeparator: function (base, state) {
        return __assign(__assign({}, base), {
          display: INDICATOR_DISPLAY,
          margin: "".concat($(theme.UNIT(1)), " ").concat($(theme.UNIT(1)), " ").concat($(theme.UNIT(1)), " ").concat($(theme.UNIT(1))),
          border: 'none',
          width: '4px',
          backgroundColor: 'transparent',
          background: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' viewbox='0 0 2 4'><circle r='1' cx='1' cy='1' fill='".concat(encodeURIComponent($(theme.COLOR('line-mid'))), "'></circle></svg>\")"),
          backgroundRepeat: "repeat-y",
          backgroundSize: "2px 4px"
        });
      },
      valueContainer: function (base, state) {
        return __assign(__assign({}, base), {
          minHeight: 50,
          // marginBottom: isMulti && isEmpty(state.selectProps.value) ? 0 : '-4px',
          padding: "0 ".concat($(theme.UNIT(1)))
        });
      },
      dropdownIndicator: function (base, state) {
        return {
          display: INDICATOR_DISPLAY,
          paddingRight: $(theme.UNIT(1)),
          paddingLeft: $(theme.UNIT(1)),
          'path, circle, polygon, rect': {
            fill: $(theme.COLOR('strong'))
          }
        };
      },
      multiValue: function (base, state) {
        return __assign(__assign({}, base), {
          borderColor: $(theme.COLOR('line-mid')),
          borderWidth: '1px',
          borderStyle: 'solid',
          backgroundColor: $(theme.COLOR('app-chrome')),
          borderRadius: '50px',
          marginRight: $(theme.UNIT(1, 2)),
          marginTop: '4px',
          marginBottom: '4px',
          padding: "0 0"
        });
      },
      multiValueRemove: function (base, state) {
        return {
          cursor: 'pointer',
          background: 'none',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          marginRight: $(theme.UNIT(4)),
          'svg': {
            width: '10px',
            height: '10px'
          },
          'path, circle, polygon, rect': {
            fill: $(theme.COLOR('text-mid'))
          },
          '&:hover': {
            background: 'none',
            'path, circle, polygon, rect': {
              fill: $(theme.COLOR('primary'))
            }
          }
        };
      },
      clearIndicator: function (base, state) {
        return {
          cursor: 'pointer',
          marginRight: $(theme.UNIT(3)),
          'svg': {
            width: '12px',
            height: '12px'
          },
          'path, circle, polygon, rect': {
            fill: $(theme.COLOR('text-mid'))
          },
          '&:hover': {
            'path, circle, polygon, rect': {
              fill: $(theme.COLOR('primary'))
            }
          }
        };
      },
      noOptionsMessage: function (base, state) {
        return __assign(__assign({}, base), {
          display: trim(state.selectProps.inputValue) ? 'flex' : 'none',
          justifyContent: 'flex-start',
          fontWeight: 400
        });
      },
      input: function (base, state) {
        return __assign(__assign({}, base), {
          marginLeft: isSearchable ? $(theme.UNIT(2)) : '2px',
          'input': {
            fontWeight: 500,
            color: "".concat($(theme.COLOR('primary')), " !important"),
            fontFamily: $(theme.FONT('sans'))
          }
        });
      },
      option: function (base, state) {
        var _a;
        var path = !state.isSelected ? {} : {
          'svg path, svg circle, svg polygon, svg rect': {
            fill: state.isSelected ? $(theme.COLOR('bright')) : 'inherit'
          }
        };
        return __assign(__assign(__assign(__assign({}, base), {
          opacity: state.isDisabled ? 0.3 : 1.0,
          cursor: state.isDisabled ? 'default' : 'pointer',
          color: state.isSelected ? $(theme.COLOR('bright')) : state.isFocused ? $(theme.COLOR('primary')) : $(theme.COLOR('text')),
          borderBottom: "1px solid ".concat($(theme.COLOR(colorVariant === 'inverted' ? 'lineDark' : 'lineSubtle'))),
          fontWeight: 400,
          fontFamily: $(theme.FONT('sans')),
          paddingLeft: padOptions ? $(theme.UNIT(3)) : '0',
          paddingRight: !padOptions && '0',
          paddingTop: padOptions ? '12px' : 0,
          paddingBottom: padOptions ? '12px' : 0,
          fontSize: '16px',
          backgroundColor: state.isSelected ? $(theme.COLOR('subtle')) : state.isFocused ? $(theme.COLOR('highlight')) : 'transparent'
        }), path), (_a = {}, _a[cn('cell-label')] = {
          color: "".concat(state.isSelected ? $(theme.COLOR('bright')) : $(theme.COLOR('text')), " !important")
        }, _a[ContentNode.cls.rule()] = {
          color: "".concat(state.isSelected ? $(theme.COLOR('bright')) : $(theme.COLOR('text')), " !important")
        }, _a));
      },
      menu: function (base, state) {
        var options = state.options,
          selectProps = state.selectProps;
        var isLoading = selectProps.isLoading,
          inputValue = selectProps.inputValue,
          variant = selectProps.variant;
        var showMenu = !(isSearchOnly && trim(inputValue) === '');
        var noMatchingResults = options.length === 0 && !isLoading && inputValue !== '';
        var padding = noMatchingResults ? $(theme.UNIT(1)) : 0;
        return __assign(__assign({}, base), {
          padding: padding,
          zIndex: 201,
          backgroundColor: $(theme.COLOR('bright')),
          display: showMenu ? 'block' : 'none',
          justifyContent: 'flex-start',
          borderRadius: 0,
          borderColor: $(theme.COLOR(variant ? 'line-semi-subtle' : 'bright')),
          marginTop: variant === 'chromeless' ? '20px' : '-2',
          maxWidth: 'none'
        });
      },
      loadingMessage: function (base, state) {
        return __assign(__assign({}, base), {
          textAlign: 'left',
          fontWeight: 400,
          padding: "".concat($(theme.UNIT(3)), " ").concat($(theme.UNIT(4))),
          color: $(theme.COLOR('text'))
        });
      }
    }, props.styles);
  }, [mode.themeMode]);
  var components = __assign({
    Input: Input,
    Option: Option,
    ClearIndicator: ClearIndicator,
    MultiValueRemove: MultiValueRemove
  }, props.components || {});
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(BaseSelect, __assign({}, selectProps, {
    debounceTimeout: 450,
    // @ts-ignore
    styles: styles,
    components: components
  })));
};
EntityBaseSelect.defaultProps = EntityBaseSelectDefaultProps;
EntityBaseSelect.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;